<template>
  <div class="flex gap-2">
    <buttons-group :buttons-props="settingsButtonsProps"
                   :selected-button="selectedSettingsButton"
                   @select-button="selectButton"
    >
      <template #default="{ slotIcon }">
        <component v-for="{ icon, tooltip } in settingsButtonsProps"
                   v-show="slotIcon === icon"
                   :alt="tooltip"
                   :is="icon"
                   :key="icon"
                   class="h-7"
        />
      </template>
    </buttons-group>

    <div class="border-solid border-r border-0 border-soft flex gap-1 pr-2">
      <base-tooltip-button v-for="({ tooltip, icon, key, isDisabled }) in zoomButtonsProps"
                           variant="bordered-icon-gray"
                           :key="key"
                           :tooltip-text="tooltip"
                           :is-disabled="isDisabled"
                           @click="$emit('zoom', key)"
      >
        <img :src="icon" :alt="tooltip" class="h-6"/>
      </base-tooltip-button>
    </div>

    <base-tooltip-button id="show-drawer-button"
                         variant="bordered-icon-gray"
                         tooltip-text="Show summary"
                         :is-disabled="isLoading"
                         @click="$emit('show-drawer')"
    >
      <img id="show-drawer-icon" :src="PieChartIcon" alt="show pie chart icon" class="h-6"/>
    </base-tooltip-button>

  </div>
</template>

<script>
import BaseTooltipButton from '@/components/base-components/BaseTooltipButton'
import ButtonsGroup from '@/components/base-components/ButtonsGroup'
import ZoomInIcon from '@/assets/images/icons/zoom-in-icon.svg'
import ZoomOutIcon from '@/assets/images/icons/zoom-out-icon.svg'
import ZoomResetIcon from '@/assets/images/icons/zoom-reset-icon.svg'
import ZoomIcon from '@/assets/images/icons/ZoomIcon'
import PanningIcon from '@/assets/images/icons/PanningIcon'
import PieChartIcon from '@/assets/images/icons/pie_chart_icon.svg'

export default {
  name: 'ChartToolbar',

  components: { ButtonsGroup, BaseTooltipButton, ZoomIcon, PanningIcon },

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    valueFrom: {
      type: Number,
      default: 0
    },
    valueTo: {
      type: Number,
      default: 100
    },
    minRange: {
      type: Number,
      default: 0
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedSettingsButton: 'selection',
      PieChartIcon
    }
  },

  computed: {
    selectedSettingsButtonValue: {
      get() {
        return this.selectedSettingsButton
      },
      set(value) {
        this.$emit('set-settings', value)
      }
    },

    settingsButtonsProps() {
      return [
        {
          tooltip: 'Selection zoom',
          icon: 'zoom-icon',
          key: 'selection',
          isDisabled: this.isLoading
        },
        { tooltip: 'Panning', icon: 'panning-icon', key: 'pan', isDisabled: this.isLoading }
      ]
    },

    zoomButtonsProps() {
      return [
        {
          tooltip: 'Zoom in',
          icon: ZoomInIcon,
          key: 'zoomIn',
          isDisabled: this.isLoading || this.valueTo - this.valueFrom <= this.minRange
        },
        {
          tooltip: 'Zoom out',
          icon: ZoomOutIcon,
          key: 'zoomOut',
          isDisabled: this.isLoading || (this.valueTo >= this.max && this.valueFrom <= this.min)
        },
        { tooltip: 'Reset to original range', icon: ZoomResetIcon, key: 'zoomReset', isDisabled: this.isLoading }
      ]
    }
  },

  methods: {
    selectButton(mode) {
      this.selectedSettingsButton = mode
      this.$emit('set-settings', mode)
    }
  }
}
</script>
